export const SET_GHANA_BANNERS = "SET_GHANA_BANNERS";
export const SET_ZAMBIA_BANNERS = "SET_ZAMBIA_BANNERS";
export const SET_CONGO_BANNERS = "SET_CONGO_BANNERS";
export const SET_CAMEROON_BANNERS = "SET_CAMEROON_BANNERS";
export const SET_CIV_BANNERS = "SET_CIV_BANNERS";
export const SET_ESWATINI_BANNERS = "SET_ESWATINI_BANNERS";
export const SET_UGANDA_BANNERS = "SET_UGANDA_BANNERS";
export const SET_PLACEHOLDER_BANNERS = "SET_PLACEHOLDER_BANNERS";
